import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { useAppUi } from '../app/useAppUi';

export function UserEditDialog({ open, user, saving, onClose, onSave }) {
  const { t } = useAppUi();
  const [name, setName] = React.useState(user?.name ?? '');
  const [email, setEmail] = React.useState(user?.email ?? '');
  const [phone, setPhone] = React.useState(user?.phone_number ?? user?.phone ?? '');
  const [agency, setAgency] = React.useState(user?.agency_name ?? user?.companyName ?? '');
  const [password, setPassword] = React.useState('');
  const [logoUrl, setLogoUrl] = React.useState(user?.logo_url ?? '');

  React.useEffect(() => {
    setName(user?.name ?? '');
    setEmail(user?.email ?? '');
    setPhone(user?.phone_number ?? user?.phone ?? '');
    setAgency(user?.agency_name ?? user?.companyName ?? '');
    setPassword('');
    setLogoUrl(user?.logo_url ?? '');
  }, [user, open]);

  const payload = React.useMemo(() => {
    const out = {};
    if (name !== '') out.name = name;
    if (email !== '') out.email = email;
    if (phone !== '') out.phone_number = phone;
    if (agency !== '') out.agency_name = agency;
    if (logoUrl !== '') out.logo_url = logoUrl;
    if (password !== '') out.password = password;
    return out;
  }, [name, email, phone, agency, logoUrl, password]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('users.editTitle')}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField label={t('users.fieldName')} value={name} onChange={(e) => setName(e.target.value)} />
          <TextField label={t('users.fieldEmail')} value={email} onChange={(e) => setEmail(e.target.value)} />
          <TextField label={t('users.fieldPhone')} value={phone} onChange={(e) => setPhone(e.target.value)} />
          <TextField label={t('users.fieldAgency')} value={agency} onChange={(e) => setAgency(e.target.value)} />
          <TextField label={t('users.fieldLogoUrl')} value={logoUrl} onChange={(e) => setLogoUrl(e.target.value)} />
          <TextField
            label={t('users.fieldPassword')}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            helperText={t('users.passwordHint')}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained" onClick={() => onSave(payload)} disabled={saving}>
          {saving ? t('common.saving') : t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

